import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SvgImage } from '..';
import { cartIcon,CartIconNew, closePopup } from '../../../style/images';
import { translate } from '../../services';
import { PropTypes } from 'prop-types';
import { combineStates,siteSettingsState} from '../../store';
import { Box, IconButton as MuiIconButton } from '@mui/material';


export class CbolCartInfoComponent extends Component {
  
  render() {
  
    const {  siteSettings } = this.props;
    let GmbHcustomer = siteSettings.externaLinks.GmbHcustomer;
    let Registration = siteSettings.externaLinks.Registration;
    let account = siteSettings.externaLinks.account;
    let notacustomer = siteSettings.externaLinks.notacustomer;

    return <div className="float-container">
              {/* <div className="float-child">
                  <img src= {CartIconNew} className="cart-icon" />
              </div> */}
              <MuiIconButton onClick={this.props.onClose} sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5",width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} style={{width: 'inherit', height: 'inherit'}} sx={{height:"24px", width:"24px"}}></Box>
      </MuiIconButton>
              <div className="float-child">
                  <div className = "cbol-cartinfo">
                    <strong >
                    <p className="header">{ translate( 'Sie möchten die Artikel aus dem Merkzettel bestellen?' ) }</p>
                    <div className="content">
                    <span>{translate('Laden sie sich den Merkzettel mit der Funktion Merkzettel exportieren (rechts oben) herunter und speichern sie sich diesen an einem bekannten Ort.')} </span>
                    <span>{translate('Wechseln Sie zum cBOL/EasyOrder und importieren Sie diesen im Bereich Preis und Verfügbarkeit mit der Funktion Excel Vorlage hochladen.')}</span>
                    </div>
                    <p className="header">{translate('Sie sind ABB STOTZ-KONTAKT GmbH Kunde')}</p>
                    <div className="content">
                    <span>{ translate( '... und haben bereits einen cBOL-Account?' ) }<a className = "cbol-links"  href ={account} target="_blank">Login</a></span>
                    <Box sx={{width:"100%", height:"1px !important", margin:"14px 0px",background:"var(--Primary-Color-Grey-10, #EBEBEB)", display:{md:"none", xs:"flex"}}}></Box>
                    <span>{ translate( '... und haben noch keinen cBOL-Account?' ) }<a className = "cbol-links" href ={Registration} target="_blank">Registrierung</a></span>
                    <Box sx={{width:"100%", height:"1px !important", margin:"14px 0px",background:"var(--Primary-Color-Grey-10, #EBEBEB)", display:{md:"none", xs:"flex"}}}></Box>
                    <span>{ translate( 'Sie sind Busch-Jaeger Elektro GmbH Kunde?' ) }<a className = "cbol-links" href ={GmbHcustomer} target="_blank">Login & Registrierung</a></span>
                    <Box sx={{width:"100%", height:"1px !important", margin:"14px 0px",background:"var(--Primary-Color-Grey-10, #EBEBEB)", display:{md:"none", xs:"flex"}}}></Box>
                    <span>{ translate( 'Sie sind noch kein Kunde?' ) }<a className = "cbol-links" href ={notacustomer} target="_blank">Kontakt</a></span>
                    <Box sx={{width:"100%", height:"1px !important", margin:"14px 0px",background:"var(--Primary-Color-Grey-10, #EBEBEB)", display:{md:"none", xs:"flex"}}}></Box>
                    </div>
                    {/* <p className="header">
                    {translate("Enter Country Name")}
                    </p>
                    <span className="content">
                    {translate("Germany")}
                    </span>
                    <p className="header">
                    {translate("URL")}
                    </p>
                    <a className = "cbol-links" href ={"https://econfigure.de.abb.com/#/cart"} target="_blank">
                    {translate("https://econfigure.de.abb.com/#/cart")}
                    </a>
                    <p className="header">
                    {translate("Instances")}
                    </p>
                    <span className="content">
                    {translate("WebCat/Pricelist")}
                    </span>
                    <p className="header">
                    {translate("Divisions - DC")}
                    </p>
                    <span className="content">
                    {translate("ELSP, ELSB, ELIP")}
                    </span> */}
                    </strong>
                  </div>
              </div>
            </div>
         ;
       }
     }
CbolCartInfoComponent.propTypes = {
  siteSettings: PropTypes.shape( {
 } )
}

export const CbolCartInfo = connect( combineStates(  siteSettingsState )) (CbolCartInfoComponent) ;